import Button from "components/ui/button"
import { IS_GE_CHECKOUT } from "helpers/application"

const shippingTermsData = [
  {
    needToKnow:
      "Repairs during this period receive free shipping to and from us.",
    shippingCost: "We will cover the shipping costs.",
    timeframe: `Within ${IS_GE_CHECKOUT() ? "30" : "99"} days`,
  },
  {
    needToKnow:
      "For all warranty claims, including replacements, you must ship your original piece to us for assessment.",
    shippingCost: "Shipping costs are on you.",
    timeframe: `After ${IS_GE_CHECKOUT() ? "30" : "99"} days`,
  },
]

const warrantyClaimData = [
  {
    details:
      "File a claim directly through our website here. You will need your order number and photos of your concerns.",

    method: "Website",
  },
  {
    details: (
      <>
        Contact us at{" "}
        <Button asChild underline>
          <a href={`mailto:${sl.config.customer_service_email}`} rel="nofollow">
            {sl.config.customer_service_email}
          </a>
        </Button>{" "}
        with your order number and photos of your concerns.
      </>
    ),
    method: "Email",
  },
]

const WarrantyTerms = () => {
  return (
    <div className="desktop:mb-60 mb-32">
      <div className="desktop:mb-60 mb-16">
        <h2 className="h2 tablet:mb-32 mb-24">Shipping & Warranty Terms</h2>
        <div className="tablet:table block w-full table-fixed border-collapse border-spacing-0 text-left">
          <div className="tablet:table-header-group hidden">
            <div className="tablet:table-row block w-full border-b border-b-black">
              <p className="h3 table-cell p-20 uppercase">Timeframe</p>
              <p className="h3 table-cell p-20 uppercase">Shipping costs</p>
              <p className="h3 table-cell p-20 uppercase">Need to know</p>
            </div>
          </div>

          <div className="tablet:table-row-group block">
            {shippingTermsData.map((data, i) => (
              <div
                className="tablet:table-row block w-full border-b border-b-black"
                key={`table-row-${i}`}
              >
                <p className="text-18 tablet:table-cell tablet:first:border-none tablet:first:font-normal tablet:first:normal-case tablet:first:w-1/2 inline-block w-1/2 p-20 align-top first:block first:w-full first:border-b first:border-b-black first:font-semibold first:uppercase">
                  {data.timeframe}
                </p>
                <p className="text-18 tablet:table-cell tablet:first:border-none tablet:first:font-normal tablet:first:normal-case tablet:first:w-1/2 inline-block w-1/2 p-20 align-top first:block first:w-full first:border-b first:border-b-black first:font-semibold first:uppercase">
                  {data.shippingCost}
                </p>
                <p className="text-18 tablet:table-cell tablet:first:border-none tablet:first:font-normal tablet:first:normal-case tablet:first:w-1/2 inline-block w-1/2 p-20 align-top first:block first:w-full first:border-b first:border-b-black first:font-semibold first:uppercase">
                  {data.needToKnow}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="desktop:mb-60 mb-32">
        <h2 className="h2 desktop:mb-20 mb-10">Out-of-Warranty Repairs</h2>
        <p className="text-16 desktop:text-18">
          If your piece is out of warranty, don&apos;t worry! You can still send
          it to us for repairs (fees apply). Contact our customer experience
          team for a quote and instructions on how to send it in.
        </p>
      </div>
      <div className="desktop:mb-60 mb-32">
        <h2 className="h2 desktop:mb-20 mb-10">How to File a Warranty Claim</h2>
        <p className="text-16 desktop:text-18">
          We make it easy to file a warranty claim. Once we have your info,
          we&apos;ll take care of the rest and direct you through the process.
          Easy as that!
        </p>
      </div>
      <div className="tablet:table mb-60 block w-full table-fixed border-collapse border-spacing-0 text-left">
        <div className="tablet:table-header-group hidden">
          <div className="tablet:table-row block w-full border-b border-b-black">
            <p className="h3 desktop:w-1/3 table-cell w-2/5 p-20 uppercase">
              Method
            </p>
            <p className="h3 desktop:w-2/3 table-cell w-2/5 p-20 uppercase">
              Details
            </p>
          </div>
        </div>

        <div className="tablet:table-row-group block">
          {warrantyClaimData.map((data, i) => (
            <div
              className="tablet:table-row block w-full border-b border-b-black"
              key={`table-row-${i}`}
            >
              <p className="text-18 tablet:table-cell tablet:w-2/3 tablet:first:font-normal tablet:first:w-1/3 inline-block w-3/5 p-20 align-top first:w-2/5 first:font-semibold">
                {data.method}
              </p>
              <p className="text-18 tablet:table-cell tablet:w-2/3 tablet:first:font-normal tablet:first:w-1/3 inline-block w-3/5 p-20 align-top first:w-2/5 first:font-semibold">
                {data.details}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="desktop:mb-60 mb-32">
        <h2 className="h2 desktop:mb-20 mb-10">Additional Caveats</h2>
        <p className="text-16 desktop:text-18">
          <b>Resizing Limit:</b> Rings can only be resized once within two full
          sizes. After that, any further sizing requires a remake, which will be
          charged at <b>30% off</b> the current price of the piece.
        </p>
      </div>
    </div>
  )
}

export default WarrantyTerms
